import {RootState} from 'redux/store';

export const getBaitBoxTagsState = (state: RootState) => state.tags;
